<div class="gw-actions-list">
    <ul class="gw-actions-list-actions">
        <slot />
    </ul>
</div>

<style>
    .gw-actions-list {
        margin: 0;
        background: var(--gw-actions-list-bg);
        padding: 8px;
        min-width: 150px;

        @media screen and (max-width: 640px) {
            min-width: 130px;
        }
    }
    .gw-actions-list-actions {
        margin: 0;
        padding: 0;
        list-style: none;
    }
</style>
